import styled from "styled-components";

export const SelectedIcon = styled.i<{ top: string; left: string }>`
  font-family: "Material Icons";
  font-size: var(--fs-xl);
  font-weight: bold;
  font-style: normal;
  width: calc(var(--u) * 30);
  color: white;
  height: calc(var(--u) * 30);
  justify-content: center;
  align-items: center;
  background-color: #4ab8fa;
  border-radius: 50%;
  display: flex;
  position: fixed;
  top: ${(props: any) => props.top.replace("%", "") - 1 + "%"};
  left: ${(props: any) => props.left.replace("%", "") - 0.5 + "%"};
  cursor: pointer;
  pointer-events: none;
  z-index: 90;
`;
export const Container = styled.div<{
  backgroundColor?: string;
  width: string;
  height: string;
}>`
  background-color: ${(props) => props.backgroundColor || "#fff"};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  display: flex;
  flex-direction: row;
  height: 100vh;
`;
export const RightMenu = styled.div<{
  componentBackgroundColor?: string;
  componentWidth: string;
  componentHeight: string;
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentStatus: string;
  selected: boolean;
}>`
  border-radius: 10px;
  background-color: ${(props) => props.componentBackgroundColor || "#000000"};
  display: flex;
  align-items: center;
  position: absolute;
  height: ${(props) => props.componentHeight};
  width: ${(props) => props.componentWidth};
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
`;
export const Header = styled.div<{ selected: boolean }>`
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  display: flex;
  align-items: center;
  margin-bottom: var(--sp-20);
`;
export const CustomerInfo = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentStatus: string;
  componentBackgroundColor: string;
  componentColor: string;
  componentFontSize: string;
  selected: boolean;
}>`
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  display: flex;
  align-items: center;
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
`;
export const CustomerInfoInput = styled.input<{
  componentPosition: { x: string; y: string };
  componentWidth: string;
  componentHeight: string;
  componentFontSize: string;
}>`
  width: ${(props) => props.componentWidth};
  height: ${(props) => props.componentHeight};
  font-size: ${(props) => props.componentFontSize};
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  margin-right: var(--sp-20);
  padding: var(--sp-5);
  border-radius: 4px;
`;
export const CustomerInfoLabel = styled.span<{
  componentFontSize: string;
}>`
  color: #000;
  font-size: ${(props) => props.componentFontSize};
`;
export const Search = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentStatus: string;
  componentColor: string;
  componentWidth: string;
  componentHeight: string;
  selected: boolean;
}>`
  width: ${(props) => props.componentWidth};
  height: ${(props) => props.componentHeight};
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  display: flex;
  align-items: center;
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
`;
export const SearchInput = styled.input<{
  componentWidth: string;
}>`
  margin-right: var(--sp-10);
  height: 100%;
  width: ${(props) => props.componentWidth};
  border-radius: 4px;
  border-radius: 10px;
`;
export const SearchButton = styled.button<{
  componentBackgroundColor: string;
  componentWidth: string;
}>`
  background-color: ${(props) => props.componentBackgroundColor};
  border-radius: 6px;
  color: white;
  font-weight: bold;
  width: ${(props) => props.componentWidth};
  height: 100%;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: var(--fs-base);
  margin-right: var(--sp-10);
  &:hover {
    filter: brightness(0.8); /* Reduz o brilho ao passar o mouse */
  }
  & .shortcut {
    font-family: "roboto";
    font-weight: bold;
    font-size: var(--fs-lg);
  }
`;
export const SaleOptionImg = styled.img`
  position: relative;
  justify-content: center;
  align-items: center;
  display: flex;
  margin: 0 auto;
  width: calc(var(--u) * 300);
  height: calc(var(--u) * 300);
`;
export const SearchIcon = styled.i<{}>`
  font-size: calc(var(--u) * 25);
  font-style: normal;
  font-weight: bold;
  margin-left: var(--sp-5);
  margin-right: var(--sp-5);
  font-family: "Material Icons"; /* Define a fonte dos ícones */
`;
export const SearchLabel = styled.span<{
  componentFontSize: string;
}>`
  margin-left: var(--sp-5);
  font-size: var(--fs-xl);
  font-weight: bold;
  font-family: "roboto";
`;
export const ExpandIcon = styled.i<{}>`
  font-size: calc(var(--u) * 25);
  font-style: normal;
  font-weight: bold;
  font-family: "Material Icons"; /* Define a fonte dos ícones */
`;
export const InfoLabels = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  selected: boolean;
}>`
  top: ${(props) => props.componentPosition.y};
  position: absolute;
  left: ${(props) => props.componentPosition.x};
  width: ${(props) => props.componentWidth};
  height: ${(props) => props.componentHeight};
  background-color: #bbcaff;
  opacity: ${(props) => props.componentBrightness};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  visibility: ${(props) => props.componentStatus};
`;
export const Label = styled.p<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  selected: boolean;
}>`
  font-weight: bold;
  margin: var(--sp-5) 0;
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  width: ${(props) => props.componentWidth};
  height: ${(props) => props.componentHeight};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
`;
export const TableWrapper = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  componentBackgroundColor: string;
  selected: boolean;
}>`
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  height: ${(props) => props.componentHeight};
  width: ${(props) => props.componentWidth};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  background-color: ${(props) => props.componentBackgroundColor};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  border-radius: 10px;
  overflow-y: auto;
`;
export const ProductTable = styled.table<{
  componentBackgroundColor: string;
  componentColor: string;
  componentFontSize: string;
}>`
  width: 100%;
  height: fit-content;
  background-color: ${(props) => props.componentBackgroundColor};
  color: ${(props) => props.componentColor};
  font-size: ${(props) => props.componentFontSize};
`;
export const ProductTableHeader = styled.thead<{
  componentColor: string;
  componentBackgroundColor: string;
}>`
  background-color: ${(props) => props.componentBackgroundColor};
  color: ${(props) => props.componentColor};
  height: calc(var(--u) * 50);
`;
export const ProductTableHeaderCell = styled.th<{
  columnWidth: string;
}>`
  padding: 0px;
  text-align: center;
  font-weight: bold;
  width: ${(props) => props.columnWidth};
  position: sticky;
  top: 0;
  background-color: inherit;
`;
export const ProductTableCellObservation = styled.th<{
  textAlign: string;
  selected: boolean;
}>`
  text-align: ${(props) => props.textAlign};
  font-weight: normal;
  position: sticky;
  top: 0;
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
`;
export const ProductTableCellComboInfo = styled.th<{
  textAlign: string;
  selected: boolean;
}>`
  text-align: ${(props) => props.textAlign};
  font-weight: normal;
  position: sticky;
  top: 0;
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
`;

export const ProductTableBody = styled.tbody<{
  componentColor: string;
}>`
  color: ${(props) => props.componentColor};
  height: fit-content;
  vertical-align: top;
`;
export const ProductTableRow = styled.tr<{}>`
  height: calc(var(--u) * 20);

  &:hover {
    cursor: pointer;
  }
`;
export const ProductTableRowObservation = styled.tr<{}>`
  text-align: left;
  white-space: nowrap;
`;
export const ProductTableCell = styled.td<{
  columnWidth: string;
  componentBackgroundColor: string;
}>`
  padding: var(--sp-5);
  text-align: center;
  font-weight: bold;
  width: ${(props) => props.columnWidth};
  border-block: 3px dotted ${(props) => props.componentBackgroundColor};
`;
export const TotalTable = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  componentBackgroundColor: string;
  selected: boolean;
}>`
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  height: ${(props) => props.componentHeight};
  width: ${(props) => props.componentWidth};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.componentBackgroundColor};
  color: white;
  align-items: center;
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  border-radius: 10px;
`;
export const TotalTableHeader = styled.thead<{}>`
  top: 0;
`;
export const TotalTableHeaderRow = styled.tr`
  height: calc(var(--u) * 10);
`;
export const TotalTableHeaderCell = styled.th<{
  columnWidth: string;
}>`
  text-align: center;
  font-weight: bold;
`;
export const TotalTableBody = styled.tbody<{
  componentBackgroundColor: string;
}>`
  width: 100%;
  display: block;
  overflow-y: auto;
  background-color: ${(props) => props.componentBackgroundColor + "90"};
  border: 1px solid #ccc;
  border-radius: 10px;
`;
export const TotalTableRow = styled.tr``;

export const TotalTableCell = styled.td`
  padding: var(--sp-5);
  text-align: center; /* Alinhado ao centro para valores */
  width: 50%;
  border-left: 1px solid #ccc;
`;
export const TotalTableWrapper = styled.table`
  width: 100%;
`;
export const Button = styled.button<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  componentBackgroundColor: string;
  componentColor: string;
  selected: boolean;
}>`
  position: absolute;
  left: ${(props) => props.componentPosition.x};
  top: ${(props) => props.componentPosition.y};
  width: ${(props) => props.componentWidth};
  height: ${(props) => props.componentHeight};
  visibility: ${(props) => props.componentStatus};
  background-color: ${(props) => props.componentBackgroundColor};
  color: white;
  border-radius: 10px;
  font-size: var(--fs-base);
  padding: var(--sp-20);
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    color: #97a7e3;
    filter: brightness(0.8); /* Reduz o brilho ao passar o mouse */
  }
  font-family: "roboto";
  font-weight: bold;
  opacity: ${(props) => props.componentBrightness};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  & .shortcut {
    font-family: "roboto";
    font-weight: bold;
    font-size: var(--fs-base);
  }
`;
export const Divider = styled.hr<{
  orientation: string;
}>`
  height: ${(props) =>
    props.orientation === "vertical" ? "calc(var(--u) * 30)" : "0px"};
  width: ${(props) =>
    props.orientation === "horizontal" ? "calc(var(--u) * 30)" : "0px"};
  margin: var(--sp-10);
  border: 1px solid #fff;
`;
export const PeriodInfoContainer = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  componentColor: string;
  selected: boolean;
}>`
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  width: ${(props) => props.componentWidth};
  height: ${(props) => props.componentHeight};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  color: ${(props) => props.componentColor};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  font-size: var(--fs-xl);
`;
export const PeriodInfoLabel = styled.div<{
  infoAlign: string;
}>`
  position: relative;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.infoAlign === "left" ? "flex-start" : "flex-end"};
  justify-content: center;
  font-weight: bold;
  font-family: "roboto";
  font-size: var(--fs-xl);
`;
export const OrderInfoContainer = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  componentColor: string;
  selected: boolean;
}>`
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  width: ${(props) => props.componentWidth};
  height: ${(props) => props.componentHeight};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  color: ${(props) => props.componentColor};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  font-size: var(--fs-xl);
`;
export const OrderInfoLabel = styled.div<{
  infoAlign: string;
}>`
  position: relative;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.infoAlign === "left" ? "flex-start" : "flex-end"};
  justify-content: center;
  font-weight: bold;
  font-family: "roboto";
  font-size: var(--fs-xl);
`;
export const OrderInfoDeliveryContainer = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  componentColor: string;
  selected: boolean;
}>`
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  width: ${(props) => props.componentWidth};
  height: ${(props) => props.componentHeight};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  color: ${(props) => props.componentColor};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  font-size: var(--fs-xl);
  overflow: hidden;
`;

export const OrderInfoDeliveryLabel = styled.div<{
  infoAlign: string;
}>`
  position: relative;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-family: "roboto";
  font-size: var(--fs-xl);
`;

export const OrderInfoDeliveryStyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-height: calc(var(--u) * 10);
  max-height: 70%;
  overflow-y: auto;
  display: block;
`;

export const OrderInfoDeliveryStyledRow = styled.tr`
  text-align: center;
  border: 1px solid #ddd;
  font-size: var(--fs-base);
`;
export const OrderInfoDeliveryStyledHeaderRow = styled.tr`
  text-align: center;
  border: 1px solid #ddd;
  font-size: var(--fs-base);
  cursor: pointer;
`;

export const OrderInfoDeliveryStyledCell = styled.td`
  text-align: center;
  width: 100%;
  min-width: calc(var(--u) * 200);
  cursor: pointer;
  &:hover {
    background-color: #0db672;
  }
`;

export const OrderInfoDeliveryStyledHeaderCell = styled.td`
  padding: var(--sp-10);
  text-align: center;
  width: 100%;
  min-width: calc(var(--u) * 100);
`;

export const TableRowRemoveButton = styled.button`
  background-color: #ff4d4d;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #ff6666;
  }
`;
export const TextInput = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentStatus: string;
  componentBackgroundColor: string;
  selected: boolean;
}>`
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  width: ${(props) => props.componentWidth};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  font-size: var(--fs-xl);
  border-radius: 6px;
  margin-right: var(--sp-10);
  input {
    width: 100%;
    font-size: var(--fs-xl);
    padding: var(--sp-4);
    border: 1.5px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
    box-shadow: 0 0 0 1px #e8e8e8,
      0 0 0 3px ${(props) => props.componentBackgroundColor};
  }

  label {
    top: 50%;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0.5;
    padding: var(--sp-4);
    transition: all 0.1s ease-in-out;
    position: absolute;
    transform: translateY(-50%);
    background-color: ${(props) => props.componentBackgroundColor};
    border-radius: 5px;
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    left: 0px;
    height: fit-content;
    width: fit-content;
    opacity: 1;
    transform: scale(0.85) translateY(-120%);
    background-color: ${(props) => props.componentBackgroundColor};
    color: white;
    font-size: var(--fs-base);
  }
`;
export const CurrentOrdersTable = styled.div<{
  componentPosition: { x: string; y: string };
  componentBrightness: string;
  componentWidth: string;
  componentHeight: string;
  componentStatus: string;
  componentBackgroundColor: string;
  componentColor: string;
  componentFontSize: string;
  selected: boolean;
}>`
  position: absolute;
  top: ${(props) => props.componentPosition.y};
  left: ${(props) => props.componentPosition.x};
  height: ${(props) => props.componentHeight};
  width: ${(props) => props.componentWidth};
  opacity: ${(props) => props.componentBrightness};
  visibility: ${(props) => props.componentStatus};
  background-color: ${(props) => props.componentBackgroundColor};
  border: ${(props) => (props.selected ? "2px dotted #4ab8fa" : "")};
  border-radius: 10px;

  .componentTitle {
    font-size: var(--fs-xl);
    font-weight: bold;
    padding: var(--sp-10);
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;
    color: ${(props) => props.componentColor};
  }
`;
export const OrdersTypeButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
export const ShowOrdersTypeButton = styled.button<{
  componentBackgroundColor: string;
}>`
  background-color: ${(props) => props.componentBackgroundColor};
  width: fit-content;
  border-radius: 6px;
  color: white;
  font-weight: bold;
  padding: var(--sp-10);
  border-radius: 10px;
  cursor: pointer;
  margin: var(--sp-10);
  &:hover {
    color: #c0cdfd;
    filter: brightness(0.8); /* Reduz o brilho ao passar o mouse */
  }
`;
export const OpenOrdersTable = styled.table<{
  componentBrightness: string;
  componentStatus: string;
  componentBackgroundColor: string;
  componentColor: string;
  componentHeight: string;
}>`
  opacity: ${(props) => props.componentBrightness};
  position: absolute;
  visibility: ${(props) => props.componentStatus};
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.componentBackgroundColor};
  align-items: center;
  width: 100%;
  height: 70%; // Adicionado
  overflow-y: auto; // Adicionado
  table-layout: fixed; // Adicionado
  border-radius: 10px;
`;

export const OpenOrdersTableHeader = styled.thead<{ componentColor: string }>`
  background-color: ${(props) => props.componentColor};
  width: 100%;
  position: sticky;
  top: 0;
`;

export const OpenOrdersTableHeaderRow = styled.tr`
  width: 100%;
  height: calc(var(--u) * 30);
  display: table; // Adicionado
`;

export const OpenOrdersTableHeaderCell = styled.th<{ columnWidth: string }>`
  padding: var(--sp-5);
  word-wrap: break-word;
  text-align: center;
  font-weight: bold;
  width: ${(props) => props.columnWidth};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OpenOrdersTableBody = styled.tbody<{
  componentBackgroundColor: string;
}>`
  width: 100%;
  background-color: ${(props) => props.componentBackgroundColor};
`;

export const OpenOrdersTableRow = styled.tr`
  width: 100%;
  height: calc(var(--u) * 30);
  background-color: #f6f6f6; // Adicionado
  display: table; // Adicionado
  cursor: pointer;
  &:hover {
    background-color: #ffffff;
    color: blue;
  }
`;

export const OpenOrdersTableCell = styled.td<{ columnWidth: string }>`
  padding: var(--sp-5);
  text-align: center;
  width: ${(props) => props.columnWidth};
  max-width: ${(props) => props.columnWidth}; // Adicionado
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block; // Adicionado
`;

export const DeliveryOrdersTable = styled.table<{
  componentBrightness: string;
  componentStatus: string;
  componentBackgroundColor: string;
  componentColor: string;
  componentHeight: string;
}>`
  opacity: ${(props) => props.componentBrightness};
  position: absolute;
  visibility: ${(props) => props.componentStatus};
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.componentBackgroundColor};
  align-items: center;
  width: 100%;
  height: 70%; // Adicionado
  overflow-y: auto; // Adicionado
  table-layout: fixed; // Adicionado
  border-radius: 10px;
`;
export const DeliveryOrdersTableHeader = styled.thead<{
  componentColor: string;
}>`
  background-color: ${(props) => props.componentColor};
  width: 100%;
  position: sticky;
  top: 0;
`;
export const DeliveryOrdersTableHeaderRow = styled.tr`
  width: 100%;
  height: calc(var(--u) * 30);
  display: table; // Adicionado
`;
export const DeliveryOrdersTableHeaderCell = styled.th<{ columnWidth: string }>`
  padding: var(--sp-5);
  word-wrap: break-word;
  text-align: center;
  font-weight: bold;
  width: ${(props) => props.columnWidth};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const DeliveryOrdersTableBody = styled.tbody<{
  componentBackgroundColor: string;
}>`
  width: 100%;
  background-color: ${(props) => props.componentBackgroundColor};
`;
export const DeliveryOrdersTableRow = styled.tr`
  width: 100%;
  height: calc(var(--u) * 30);
  background-color: #f6f6f6; // Adicionado
  display: table; // Adicionado
  cursor: pointer;
  &:hover {
    background-color: #ffffff;
    color: blue;
  }
`;
export const DeliveryOrdersTableCell = styled.td<{ columnWidth: string }>`
  padding: var(--sp-5);
  text-align: center;
  width: ${(props) => props.columnWidth};
  max-width: ${(props) => props.columnWidth}; // Adicionado
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block; // Adicionado
`;
